import React from "react";
import CurvedMorphingText from './CurvedMorphingText';

const Ripple = React.memo(function Ripple({
  mainCircleSize = 210,
  mainCircleOpacity = 0.24,
  numCircles = 8,
  className = "",
  onFirstCircleClick,
  isTransitioning = false,
  ...props
}) {
  // Keep desktop sizing for mobile to maintain consistency
  const viewportSize = Math.min(window.innerWidth, window.innerHeight);
  const isMobile = viewportSize < 768;
  
  // Use fixed sizing that works well on both desktop and mobile
  const responsiveMainSize = isMobile ? Math.max(mainCircleSize, 350) : Math.max(mainCircleSize, viewportSize * 0.35);
  const increment = isMobile ? 140 : Math.max(100, viewportSize * 0.15);

  return (
    <div
      className={`absolute inset-0 select-none ${className}`}
      {...props}
    >
      {Array.from({ length: numCircles }, (_, i) => {
        const size = responsiveMainSize + i * increment;
        const opacity = mainCircleOpacity - i * 0.04;
        const animationDelay = `${i * 0.12}s`;
        const borderStyle = "solid";

        const isFirstCircle = i === 0;
        const transitionScale = isTransitioning && isFirstCircle ? 'scale(3)' : 'scale(1)';
        const transitionOpacity = isTransitioning && isFirstCircle ? 1 : opacity;
        const transitionDuration = isFirstCircle ? 'transition-all duration-1000 ease-out' : '';

        return (
          <div
            key={i}
            className={`animate-ripple absolute rounded-full flex items-center justify-center ${transitionDuration} ${isFirstCircle ? 'cursor-pointer hover:scale-105 pointer-events-auto' : 'pointer-events-none'}`}
            onClick={isFirstCircle ? onFirstCircleClick : undefined}
            style={{
              "--i": i,
              width: `${size}px`,
              height: `${size}px`,
              opacity: transitionOpacity,
              animationDelay: animationDelay,
              borderStyle: borderStyle,
              borderWidth: "1px",
              borderColor: `rgba(59, 130, 246, ${0.4 - i * 0.04})`,
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%) ${transitionScale}`,
              background: isTransitioning && isFirstCircle 
                ? 'rgba(255, 255, 255, 1)' 
                : `radial-gradient(circle, rgba(59, 130, 246, ${0.15 - i * 0.015}) 0%, rgba(59, 130, 246, ${0.05 - i * 0.005}) 50%, transparent 70%)`,
              boxShadow: `0 0 ${20 + i * 5}px rgba(59, 130, 246, ${0.3 - i * 0.03})`,
              zIndex: isFirstCircle ? 20 : 10 - i,
            }}
          >
            {isFirstCircle && (
              <h1 
                className={`text-5xl sm:text-6xl md:text-6xl lg:text-8xl font-bold tracking-tighter z-10 select-none transition-colors duration-1000 pointer-events-none animate-text-pulse ${
                  isTransitioning ? 'text-black' : 'text-white'
                }`}
                style={{
                  animation: `textPulse 4s ease calc(var(--i, 0) * 0.3s) infinite`,
                  textShadow: '0 0 20px rgba(255, 255, 255, 0.5)',
                }}
              >
                Dev Mondal
              </h1>
            )}
            {i === 1 && (
              <CurvedMorphingText 
                texts={["Full-Stack Developer", "Tech Innovator", "Open Source Enthusiast", "Lifelong Learner"]}
                className="animate-text-pulse"
                animationDelay={parseFloat(animationDelay) * 1000} // Convert to milliseconds
                style={{
                  animation: `textPulse 4s ease calc(var(--i, 0) * 0.3s) infinite`,
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
});

Ripple.displayName = "Ripple";

export default Ripple;